import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import moment from 'moment'
import Link from '../utils/link';

import usePostsQuery from '../hooks/use-posts-query';

const Media = () => {
  const { allWpPost } = usePostsQuery();
  const posts = JSON.parse(JSON.stringify(allWpPost));
  const firstPost = posts.nodes.shift()
  
  return (
    <>
      <section className="page-header">
        <div className="page-header__inner">
          <Link className="page-header__wrapper" to={firstPost.uri}>
            <GatsbyImage image={getImage(firstPost.featuredImage?.node?.localFile)} alt={firstPost.title} />
            <h2>{ firstPost.title }</h2>
          </Link>
        </div>
      </section>

      <section className="media media--projects">
        <div className="media__inner">
          { posts.nodes.map(({title, uri, date, featuredImage}, index) => (
            <Link className="media__item" key={index} to={uri}>
              <div className="latest-media">
                <GatsbyImage image={getImage(featuredImage?.node?.localFile)} alt={title} />
                <h2>{ title }</h2>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </>
  )
}

export default Media